import { legacy_createStore as createStore , applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';

import rootReducer from './reducers';

function saveToLocalStorage(state) {

    try {
      const serialisedState = JSON.stringify(state);
      sessionStorage.setItem("persistantState", serialisedState);
    } catch (e) {
      console.warn(e);
    }
  }

  function loadFromLocalStorage() {
    try {

      const serialisedState = sessionStorage.getItem("persistantState");
      if (serialisedState === null) return undefined;
      return JSON.parse(serialisedState);
    } catch (e) {
      console.warn(e);
      return undefined;
    }
  }

  function configureStore()  {

    const persistedState = loadFromLocalStorage();
    const store = createStore(rootReducer, persistedState,applyMiddleware(thunk));
  
    store.subscribe(() => saveToLocalStorage(store.getState()))
  
    return store
  }

  const store = configureStore();


export default store;
